import { useState, useEffect } from 'react';

let promise = null;
let cache = null;

export interface IMccData {
  MCC: string;
  DescriptionEN: string;
  DescriptionFR: string;
}

export function useMccRef() {
  const [data, setData] = useState<IMccData[]>(cache);

  useEffect(() => {
    if (cache) {
      return;
    }

    if (!promise) {
      promise = import('@/assets/mccCode.json').then((module) => {
        cache = module.default;
        return cache;
      });
    }

    promise.then((resolvedData) => {
      setData(resolvedData);
    });
  }, []);

  return data;
}
